export default __webpack_public_path__ + "static/media/diamond.eaa80974.jpg";